type Classes = {
  [index: string]: boolean;
};

export const classNames = (obj: Classes) =>
  Object.keys(obj)
    .filter(key => key && obj[key])
    .join(' ');
